import { type ComponentPropsWithoutRef, type ReactElement, useId } from 'react';

import styles from './fields.module.css';

export interface TextFieldProps extends ComponentPropsWithoutRef<'input'> {
    label: string;
    error?: string | undefined;
    /** Short helper text under the control. */
    hint?: string | undefined;
}

export function TextField({ label, error, hint, id, ...rest }: TextFieldProps): ReactElement {
    const generatedId = useId();
    const fieldId = id ?? generatedId;
    const errorId = `${fieldId}-error`;
    const hintId = `${fieldId}-hint`;
    const describedBy = [hint !== undefined ? hintId : null, error !== undefined ? errorId : null]
        .filter((item) => item !== null)
        .join(' ');
    return (
        <div className={styles.field}>
            <label className={styles.label} htmlFor={fieldId}>
                {label}
            </label>
            <input
                id={fieldId}
                className={styles.control}
                aria-invalid={error !== undefined || undefined}
                aria-describedby={describedBy.length > 0 ? describedBy : undefined}
                {...rest}
            />
            {hint !== undefined ? (
                <p id={hintId} className={styles.hint}>
                    {hint}
                </p>
            ) : null}
            {error !== undefined ? (
                <p id={errorId} className={styles.error}>
                    {error}
                </p>
            ) : null}
        </div>
    );
}
